export default "__VITE_ASSET__MhQY1HZq__"